/* Boosted Engineering redesign (1 Nov 2026): cursor effects, AJAX add to cart + toast, header dropdown placement,
   My garage helpers, best-seller fit order, stage package tabs, UniClutch picker.
   The vehicle data and search logic stay in be-finder.js / be-fitment.js; this file only reads the saved car (localStorage be-vehicle). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mm = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var reduced = mm('(prefers-reduced-motion: reduce)');
  var fine = mm('(hover: hover) and (pointer: fine)') && !reduced;
  var T = function (k, def) { return window.beT ? window.beT(k, def) : def; };
  var isEn = (root.lang || 'en').toLowerCase().indexOf('en') === 0;
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var car = null;
  try { car = JSON.parse(localStorage.getItem('be-vehicle') || 'null'); } catch (e) { car = null; }

  /* ---------- Cursor effects ---------- */
  var lastM = null, lastT = null;
  var resetM = function (el) { el.style.setProperty('--tx', '0px'); el.style.setProperty('--ty', '0px'); };
  var resetT = function (el) { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); };
  if (fine) {
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') { return; }
      var t = e.target && e.target.closest ? e.target : null;
      var m = t ? t.closest('.fx.mag') : null, tl = t ? t.closest('.fx.tilt') : null;
      if (lastM && lastM !== m) { resetM(lastM); }
      if (lastT && lastT !== tl) { resetT(lastT); }
      lastM = m; lastT = tl;
      var r, x, y;
      if (m) {
        r = m.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top;
        m.style.setProperty('--mx', x + 'px'); m.style.setProperty('--my', y + 'px');
        m.style.setProperty('--tx', ((x - r.width / 2) * 0.22).toFixed(1) + 'px');
        m.style.setProperty('--ty', ((y - r.height / 2) * 0.35).toFixed(1) + 'px');
      }
      if (tl) {
        var a = tl.hasAttribute('data-soft') ? 4 : 10;
        r = tl.getBoundingClientRect(); x = e.clientX - r.left; y = e.clientY - r.top;
        tl.style.setProperty('--mx', x + 'px'); tl.style.setProperty('--my', y + 'px');
        tl.style.setProperty('--ry', (((x / r.width) - 0.5) * a).toFixed(2) + 'deg');
        tl.style.setProperty('--rx', (((y / r.height) - 0.5) * -a).toFixed(2) + 'deg');
      }
    }, { passive: true });
    root.addEventListener('mouseleave', function () {
      if (lastM) { resetM(lastM); } if (lastT) { resetT(lastT); }
      lastM = null; lastT = null;
    });
  }

  /* ---------- Cart count + toast ---------- */
  var setCount = function (n) {
    d.querySelectorAll('[data-be-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  };
  var toast = null, toastTimer = null;
  var showToast = function (title, isError) {
    if (!toast) {
      toast = d.createElement('div');
      toast.className = 'rd-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      d.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var txt = d.createElement('span');
    if (isError) {
      txt.textContent = title;
    } else {
      var ic = d.createElement('span');
      ic.className = 'rd-toast__ic';
      ic.innerHTML = '<svg width=\'14\' height=\'14\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'#fff\' stroke-width=\'3\' stroke-linecap=\'round\' stroke-linejoin=\'round\' aria-hidden=\'true\'><path d=\'M5 12l5 5L20 7\'></path></svg>';
      toast.appendChild(ic);
      txt.textContent = T('product.added', 'Added to cart') + ': ';
      var b = d.createElement('strong');
      b.textContent = title;
      txt.appendChild(b);
    }
    toast.appendChild(txt);
    var a = d.createElement('a');
    a.href = base + 'cart';
    a.textContent = T('product.view_cart', 'View cart');
    toast.appendChild(a);
    void toast.offsetWidth;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  };
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rd-add]') : null;
    if (!b) { return; }
    e.preventDefault();
    if (b.disabled) { return; }
    var label = b.textContent;
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    b.textContent = T('product.adding', 'Adding...');
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-rd-add'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body.description || res.body.message || T('product.add_error', 'Could not add to cart')); }
        showToast(b.getAttribute('data-title') || '');
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function (err) { showToast(err.message || T('product.add_error', 'Could not add to cart'), true); })
      .then(function () { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = label; });
  });

  /* ---------- Header: place dropdowns under their button (the nav row scrolls sideways) ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.rd-hd [data-be-drop]') : null;
    if (!b) { return; }
    var dr = b.parentNode.querySelector('.be-drop');
    if (!dr) { return; }
    var r = b.getBoundingClientRect();
    var w = Math.min(300, window.innerWidth - 32);
    dr.style.top = Math.round(r.bottom + 6) + 'px';
    dr.style.left = Math.round(Math.max(16, Math.min(r.left, window.innerWidth - w - 16))) + 'px';
    dr.style.width = w + 'px';
  }, true);
  var closeDrops = function () {
    d.querySelectorAll('.rd-hd .be-drop.is-open').forEach(function (dr) {
      dr.classList.remove('is-open');
      var b = dr.parentNode.querySelector('[data-be-drop]');
      if (b) { b.setAttribute('aria-expanded', 'false'); }
    });
  };
  window.addEventListener('resize', closeDrops);

  var init = function () {
    var nav = d.querySelector('.rd-hd__nav');
    if (nav) { nav.addEventListener('scroll', closeDrops, { passive: true }); }

    /* ---------- My garage ---------- */
    var f = d.querySelector('.rd-garage[data-be-finder]');
    if (f) {
      var sync = function () {
        var mk = f.querySelector('[data-be-make]'), md = f.querySelector('[data-be-model]'), gn = f.querySelector('[data-be-gen]'), go = f.querySelector('[data-be-go]');
        if (!mk || !md || !gn || !go) { return; }
        md.disabled = md.options.length < 2;
        gn.disabled = gn.options.length < 2;
        var lbl = go.getAttribute('data-default') || go.textContent;
        if (!mk.value) { lbl = T('col.choose_car', 'Choose your car'); }
        else if (isEn && md.value) { lbl = 'Save my ' + md.value + ' and show parts'; }
        else if (isEn) { lbl = 'Show ' + mk.value + ' parts'; }
        if (go.textContent !== lbl) { go.textContent = lbl; }
        go.classList.toggle('is-off', !mk.value);
      };
      f.addEventListener('change', function () { setTimeout(sync, 0); });
      if (window.MutationObserver) { new MutationObserver(function () { sync(); }).observe(f, { childList: true, subtree: true }); }
      sync();
      var clr = f.querySelector('[data-rd-clear]');
      if (clr) {
        clr.hidden = !car;
        clr.addEventListener('click', function () {
          try { localStorage.removeItem('be-vehicle'); } catch (e) {}
          window.location.reload();
        });
      }
    }
    var bar = d.querySelector('[data-rd-carbar]');
    if (bar && car && car.label) {
      var bt = bar.querySelector('[data-rd-carbar-text]');
      if (bt) {
        bt.textContent = '';
        var s1 = d.createTextNode(isEn ? 'Shopping for ' : T('col.your_car', 'Your car') + ': ');
        var st = d.createElement('strong'); st.textContent = car.label;
        bt.appendChild(s1); bt.appendChild(st);
        if (isEn) { bt.appendChild(d.createTextNode('. Parts that fit are marked with a green tick.')); }
      }
      bar.hidden = false;
      var ch = bar.querySelector('[data-rd-change]');
      if (ch && f) {
        ch.addEventListener('click', function () {
          f.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          var mk = f.querySelector('[data-be-make]');
          if (mk) { setTimeout(function () { try { mk.focus({ preventScroll: true }); } catch (e) { mk.focus(); } }, reduced ? 0 : 400); }
        });
      }
    }

    /* ---------- Best sellers: parts that fit the saved car first (ticks come from be-fitment.js) ---------- */
    var grid = d.querySelector('[data-rd-best]');
    if (grid && car && car.tokens && car.tokens.length) {
      var short = car.model || car.label || '';
      var ttl = d.querySelector('[data-rd-best-title]');
      if (ttl && isEn && short) { ttl.textContent = ttl.textContent.replace(/\s+$/, '') + ' for your ' + short; }
      var fit = [], uni = [], other = [];
      [].slice.call(grid.children).forEach(function (c) {
        if (c.classList.contains('is-fit')) {
          fit.push(c);
          var fb = c.querySelector('[data-be-fitbadge]');
          if (fb && isEn && short) { fb.textContent = '✓ Fits your ' + short; }
        } else if (c.hasAttribute('data-rd-universal')) {
          uni.push(c);
        } else {
          other.push(c);
          var nl = c.querySelector('[data-rd-notlisted]');
          if (nl) { nl.textContent = T('col.not_listed', 'Not listed for your') + ' ' + (short || T('col.your_car', 'car')); nl.hidden = false; }
        }
      });
      fit.concat(uni, other).forEach(function (c) { grid.appendChild(c); });
    }

    /* ---------- Stage packages ---------- */
    d.querySelectorAll('[data-rd-stages]').forEach(function (box) {
      var tabs = [].slice.call(box.querySelectorAll('[data-rd-tab]'));
      var cards = [].slice.call(box.querySelectorAll('[data-rd-stage]'));
      var cta = box.querySelector('[data-rd-stage-cta]');
      var idx = 1;
      var pickStage = function (c) {
        cards.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        if (c && cta) {
          cta.href = c.getAttribute('data-url');
          var sp = cta.querySelector('span');
          if (sp) { sp.textContent = c.getAttribute('data-cta'); }
        }
      };
      var vis = function (p) { return cards.filter(function (c) { return c.getAttribute('data-plat') === p; }); };
      var pickPlat = function (p) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-rd-tab') === p ? 'true' : 'false'); });
        cards.forEach(function (c) { c.hidden = c.getAttribute('data-plat') !== p; });
        var v = vis(p);
        if (v.length) { pickStage(v[Math.min(idx, v.length - 1)]); }
      };
      tabs.forEach(function (t) { t.addEventListener('click', function () { pickPlat(t.getAttribute('data-rd-tab')); }); });
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          var v = vis(c.getAttribute('data-plat'));
          idx = Math.max(0, v.indexOf(c));
          pickStage(c);
        });
      });
      var start = tabs[0] ? tabs[0].getAttribute('data-rd-tab') : null;
      if (car && car.tokens) {
        var toks = car.tokens.map(function (x) { return String(x).toLowerCase(); });
        tabs.forEach(function (t) {
          var tt = (t.getAttribute('data-tokens') || '').split(',').map(function (x) { return x.trim(); });
          if (tt.some(function (x) { return x && toks.indexOf(x) !== -1; })) { start = t.getAttribute('data-rd-tab'); }
        });
      }
      if (start) { pickPlat(start); }
    });

    /* ---------- UniClutch picker ---------- */
    var uc = d.querySelector('[data-rd-uc]');
    if (uc) {
      var chips = [].slice.call(uc.querySelectorAll('[data-rd-uchip]'));
      var pops = [].slice.call(uc.querySelectorAll('[data-rd-pop]'));
      var q = function (n) { return uc.querySelector('[data-uc-' + n + ']'); };
      var setTxt = function (n, v) { var el = q(n); if (el) { el.textContent = v || ''; } };
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.getAttribute('aria-pressed') === 'true') { return; }
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          setTxt('name', c.getAttribute('data-name'));
          setTxt('short', c.getAttribute('data-short'));
          setTxt('years', c.getAttribute('data-years'));
          setTxt('price', c.getAttribute('data-price'));
          setTxt('mount', c.getAttribute('data-mount'));
          setTxt('spline', c.getAttribute('data-spline'));
          var img = q('img');
          if (img && c.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = c.getAttribute('data-img'); img.alt = c.getAttribute('data-name') || ''; }
          var link = q('cta');
          if (link) { link.href = c.getAttribute('data-url'); }
          if (!reduced) {
            pops.forEach(function (p) { p.classList.remove('rd-pop'); void p.offsetWidth; p.classList.add('rd-pop'); });
          }
        });
      });
    }
  };
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); }); } else { setTimeout(init, 0); }
})();
